import { render, staticRenderFns } from "./CategoryInfo.vue?vue&type=template&id=5674efa8&"
import script from "./CategoryInfo.vue?vue&type=script&lang=js&"
export * from "./CategoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./CategoryInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports